import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="settings"
export default class extends Controller {
	static targets = ["sidebar"];

	toggle() {
		this.sidebarTarget.classList.toggle("w-0");
		this.sidebarTarget.classList.toggle("w-48");
	}
}
